var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAgencyLogoBusiness = function SvgAgencyLogoBusiness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 248.988,
    height: 117.819,
    viewBox: "0 0 248.988 117.819"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 12.997,
    height: 17.743,
    transform: "translate(0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M13.6,485.445v-.356c.833-.278,1.008-1.038,1.008-2.853V470.984c0-1.816-.175-2.575-1.008-2.853v-.351H25.711l.277,3.56-.33.073c-1.005-2.47-2.6-3.227-5.422-3.227H17.284v7.569h2.424c3.078,0,3.96-.6,4.364-1.918h.355v4.239h-.355c-.4-1.313-1.286-1.918-4.364-1.918H17.284v7.621a1.143,1.143,0,0,0,1.263,1.26H20.97c2.548,0,4.291-.756,5.25-3.33l.326.049-.175,3.686H13.6Z",
    transform: "translate(-13.6 -467.78)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 13.129,
    height: 17.871,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M12.95,484.892v-.419l.061-.02c.765-.258.948-.935.948-2.769h0V470.431h0c0-1.83-.184-2.516-.948-2.769l-.061-.018v-.5H25.233l.29,3.713-.473.11-.03-.072c-.99-2.43-2.544-3.174-5.343-3.174H16.725v-.084h.088V475.2h-.088v-.088h2.424v0c3.07,0,3.9-.6,4.28-1.853l.016-.064h.507v4.416h-.51l-.016-.062c-.387-1.255-1.21-1.856-4.28-1.856H16.723v-.088h.088v7.621h0a1.058,1.058,0,0,0,1.175,1.173v0h2.423v0c2.523,0,4.223-.745,5.166-3.275l.024-.066.477.073-.182,3.848H12.95v-.088m.175,0h-.088V484.8H25.8v.088l-.088,0,.175-3.686.088,0-.015.088-.327-.049.015-.088.08.031c-.977,2.617-2.758,3.387-5.328,3.387H17.98a1.23,1.23,0,0,1-1.35-1.348v-7.709h2.512c3.089,0,4.028.608,4.448,1.982l-.084.024v-.088h.355v.088h-.088v-4.239h.088v.088h-.351v-.088l.084.024c-.423,1.374-1.363,1.982-4.448,1.982H16.634v-7.746h3.039c2.849,0,4.479.769,5.506,3.284l-.08.031-.022-.084.331-.073.02.084-.088.007-.278-3.56.088-.007v.088H13.038v-.088h.088v.355h-.088l.03-.084c.9.3,1.066,1.134,1.066,2.933v11.256c0,1.8-.168,2.634-1.066,2.933l-.03-.084h.088v.355Z",
    transform: "translate(-12.95 -467.14)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 6.813,
    height: 8.461,
    transform: "translate(0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M22.147,822.092c0-1.2-.807-1.892-2.35-1.892H17.745v3.786H19.8c1.542,0,2.35-.688,2.35-1.894m1.206,0c0,1.835-1.328,2.944-3.52,2.944H17.745v2.558h-1.2V819.15h3.292C22.029,819.15,23.353,820.258,23.353,822.092Z",
    transform: "translate(-16.54 -819.15)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 6.126,
    height: 8.444,
    transform: "translate(0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M148.145,826.541v1.046H142.02V819.15h5.954v1.05h-4.748v2.592h4.232v1.025h-4.232v2.727Z",
    transform: "translate(-142.02 -819.15)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 16.601,
    height: 17.711,
    transform: "translate(0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M151.99,468.135v-.355h4.643v.355c-.833.277-.5.935.152,2.624l4.641,11.784,4.567-11.784c.657-1.689.482-2.421-.379-2.624v-.355h2.926v.355c-.756.277-1.412.935-2.07,2.624l-5.7,14.686h-.955l-5.931-14.686C153.227,469.066,152.571,468.411,151.99,468.135Z",
    transform: "translate(-151.99 -467.78)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 16.761,
    height: 17.868,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M151.34,467.582v-.442h4.82v.5l-.058.022c-.492.161-.541.45-.289,1.2l.362.965c.042.108.088.22.133.34l-.08.031.08-.031,4.641,11.782-.08.033-.08-.033,4.567-11.782c.608-1.568.467-2.218-.133-2.451l-.115-.041-.133-.031v-.513h3.1v.5l-.057.022c-.723.263-1.363.893-2.016,2.571l-5.729,14.746h-1.08l-5.954-14.743c-.65-1.682-1.3-2.314-1.848-2.579l-.049-.02v-.057m.172,0h-.088l.038-.08c.612.29,1.279.97,1.936,2.67l-.08.031.08-.031,5.931,14.684-.08.033V484.8h.959v.088l-.08-.033,5.7-14.684.08.031-.08-.031c.661-1.7,1.328-2.386,2.119-2.674l.031.08H167.9v-.351h.088v.088h-2.93v-.088h.088v.355h-.088l.02-.084.141.038.064.024c.772.3.833,1.138.235,2.676l-.08-.031.08.031-4.648,11.99-4.725-11.99c-.046-.119-.091-.231-.133-.34l-.366-.974c-.252-.757-.248-1.207.4-1.426l.027.084h-.088v-.355h.088v.088h-4.641v-.088h.088v.355Z",
    transform: "translate(-151.34 -467.14)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 6.956,
    height: 8.451,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M269.377,822.092c0-1.2-.807-1.892-2.349-1.892h-2.051V824h2.051c1.542,0,2.349-.7,2.349-1.9m.037,5.5L267.593,825c-.168.011-.347.026-.53.026h-2.086v2.567H263.77v-8.44h3.292c2.2,0,3.52,1.108,3.52,2.942a2.67,2.67,0,0,1-1.858,2.668l2,2.834-1.313,0Z",
    transform: "translate(-263.77 -819.15)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 6.525,
    height: 8.656,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M384.9,826.015l.446-.943a4.355,4.355,0,0,0,2.786.977c1.457,0,2.086-.566,2.086-1.3,0-2.065-5.116-.76-5.116-3.9,0-1.3,1.016-2.409,3.233-2.409a4.938,4.938,0,0,1,2.712.749l-.4.963a4.348,4.348,0,0,0-2.314-.688c-1.432,0-2.047.6-2.047,1.337,0,2.062,5.11.775,5.11,3.872,0,1.29-1.035,2.4-3.266,2.4a5.028,5.028,0,0,1-3.233-1.061v0Z",
    transform: "translate(-384.9 -818.44)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 14.724,
    height: 17.918,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M402.881,472.425a4.117,4.117,0,0,0-4.467-4.239l-1.108.077v7.717h1.616c2.876,0,3.964-1.616,3.964-3.56m-.229,8.881c-1.515-3.686-1.641-4.922-3.861-4.922h-1.489v5.86c0,1.815.175,2.575,1.008,2.853v.351H393.62v-.351c.833-.278,1.008-1.038,1.008-2.853V470.984c0-1.816-.175-2.575-1.008-2.853v-.351h5.3c5.5,0,6.636,2,6.636,4.037,0,2.322-1.593,4.062-4.947,4.464,2.854.331,3.409,1.515,4.742,4.871s1.617,3.961,2.548,3.961h.254l.126.327a8.2,8.2,0,0,1-1.816.175c-2.093,0-2.6-1.363-3.812-4.315h.007Z",
    transform: "translate(-393.62 -467.78)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 14.907,
    height: 18.062,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M402.248,471.872a4.032,4.032,0,0,0-4.379-4.152l-1.1.073-.009-.088h.088v7.721h-.088v-.088h1.616v0c2.826,0,3.876-1.574,3.876-3.471h0m.176,0c0,1.989-1.122,3.646-4.051,3.646h-1.7v-7.883l.077-.011,1.12-.077a4.206,4.206,0,0,1,4.554,4.327l0,0Zm-.4,8.916-.566-1.409c-.137-.351-.263-.666-.384-.959-.765-1.861-1.234-2.5-2.831-2.5h-1.485v-.088h.088v5.858h0c0,1.83.184,2.512.948,2.769l.061.02v.507H392.99v-.51l.058-.02c.766-.256.95-.935.95-2.769h0V470.432h0c0-1.83-.187-2.516-.95-2.769l-.058-.016v-.507h5.385v0c5.527,0,6.724,2.013,6.724,4.124h0c0,2.379-1.637,4.147-5.025,4.553l-.011-.088.011-.088c2.906.335,3.478,1.568,4.818,4.926,1.352,3.394,1.609,3.907,2.465,3.907v0h.247l.221-.046v.526l-.068.018a8.274,8.274,0,0,1-1.837.179c-2.112,0-2.663-1.367-3.8-4.15l-.061-.142.053-.106-.08.035m.159-.065.088.218c1.156,2.818,1.664,4.04,3.64,4.04a8.172,8.172,0,0,0,1.795-.172l.022.084h-.088v-.351h.088l.016.088-.269.027h-.128c-1.008,0-1.306-.7-2.632-4.018l.08-.033-.08.033c-1.333-3.356-1.876-4.494-4.672-4.818l-.741-.084.741-.088c3.326-.4,4.869-2.115,4.869-4.376,0-1.974-1.076-3.949-6.549-3.949h-5.3v-.095h.088v.355h-.088l.027-.084c.9.3,1.069,1.134,1.069,2.933v11.257c0,1.8-.17,2.634-1.069,2.933l-.027-.084h.088v.351h-.088V484.8h4.694v.088h-.088v-.351h.088l-.03.084c-.9-.3-1.066-1.134-1.066-2.933v-5.944h1.578c1.707,0,2.223.732,2.994,2.607l.383.959c.168.425.351.893.562,1.405l0,.007Z",
    transform: "translate(-392.99 -467.14)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 8.969,
    height: 8.668,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M510.684,822.758A3.28,3.28,0,1,0,507.416,826a3.167,3.167,0,0,0,3.268-3.242m-7.763,0a4.487,4.487,0,1,1,4.5,4.316A4.288,4.288,0,0,1,502.92,822.758Z",
    transform: "translate(-502.92 -818.44)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 12.997,
    height: 17.742,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M545.77,485.445v-.356c.833-.278,1.008-1.038,1.008-2.853V470.984c0-1.816-.175-2.575-1.008-2.853v-.351h12.111l.277,3.56-.33.073c-1.005-2.47-2.6-3.227-5.422-3.227h-2.952v7.569h2.424c3.078,0,3.96-.6,4.364-1.918h.352v4.239h-.352c-.4-1.313-1.286-1.918-4.364-1.918h-2.424v7.621a1.143,1.143,0,0,0,1.263,1.26h2.424c2.548,0,4.289-.756,5.249-3.33l.327.049-.175,3.686H545.77Z",
    transform: "translate(-545.77 -467.78)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M545.121,484.892v-.419l.061-.02c.766-.258.948-.935.948-2.769h0V470.431h0c0-1.83-.185-2.516-.948-2.769l-.061-.018v-.5H557.4l.29,3.713-.473.11-.03-.072c-.99-2.43-2.544-3.174-5.343-3.174H548.9v-.084h.088V475.2H548.9v-.088h2.424v0c3.07,0,3.9-.6,4.284-1.853l.016-.064h.507v4.416h-.514l-.016-.062c-.387-1.255-1.213-1.856-4.284-1.856h-2.423v-.088h.088v7.621h0a1.057,1.057,0,0,0,1.173,1.173v0h2.424v0c2.522,0,4.221-.745,5.163-3.275l.024-.066.479.073-.183,3.848H545.12v-.088m.176,0h-.088V484.8h12.768v.088l-.088,0,.175-3.686.088,0-.015.088-.327-.049.015-.088.08.031c-.977,2.617-2.758,3.387-5.329,3.387h-2.424a1.229,1.229,0,0,1-1.349-1.348v-7.709h2.511c3.085,0,4.028.608,4.448,1.982l-.084.024v-.088h.351v.088h-.088v-4.239h.088v.088h-.351v-.088l.084.024c-.421,1.374-1.363,1.982-4.448,1.982h-2.508v-7.746h3.039c2.849,0,4.479.769,5.506,3.284l-.08.031-.022-.084.331-.073.02.084-.088.007-.277-3.56.088-.007v.088H545.208v-.088h.088v.355h-.088l.03-.084c.9.3,1.066,1.134,1.066,2.933v11.256c0,1.8-.168,2.634-1.066,2.933l-.03-.084h.088v.355Z",
    transform: "translate(-545.12 -467.14)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 7.259,
    height: 8.45,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M652.106,819.15v8.44h-.986l-5.067-6.294v6.294h-1.2v-8.44h.986l5.067,6.294V819.15Z",
    transform: "translate(-644.85 -819.15)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 17.242,
    height: 17.893,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M691.634,477.177l-3.257-7.8-3.154,7.8Zm-10.624,6.636c.756-.278,1.437-.935,2.119-2.624l4.717-11.711a1.523,1.523,0,0,0-.049-1.363l-.326-.707,2.472-1.108,6.258,14.912c.707,1.664,1.363,2.322,1.943,2.6v.355h-4.6v-.355c.833-.278.482-.935-.225-2.6l-1.513-3.633H685.07l-1.46,3.608c-.682,1.689-.53,2.421.326,2.624v.355H681.01v-.355Z",
    transform: "translate(-681.01 -466.3)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 17.388,
    height: 18.137,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M690.974,476.456l-3.257-7.795.08-.035.08.031-3.154,7.795-.08-.031v-.088h6.411v.088l-.08.035m.161-.066.049.122h-6.671l3.281-8.115,3.337,8ZM680.4,482.977c.723-.267,1.391-.9,2.068-2.576l4.719-11.706.08.031-.08-.031a1.432,1.432,0,0,0-.049-1.294l-.366-.787,2.634-1.184,6.3,15-.08.035.08-.035c.7,1.654,1.348,2.291,1.9,2.554l.049.024v.5h-4.772V483l.061-.02c.457-.152.52-.408.309-1.04-.1-.294-.252-.654-.442-1.1l-.145-.342-1.514-3.632.08-.035v.088h-6.739v-.088l.083.031-1.462,3.612-.08-.031.08.031c-.629,1.559-.514,2.21.073,2.444l.122.042.137.033v.509h-3.1V483l.057-.02m.061.163-.031-.08h.091v.355h-.088v-.088h2.926v.088h-.088v-.355h.088l-.02.084-.152-.042-.066-.027c-.76-.305-.787-1.145-.169-2.675l1.488-3.663h6.851l1.538,3.688-.083.035.083-.035.143.336c.19.446.347.817.45,1.118.218.656.183,1.061-.421,1.26l-.03-.084h.088v.355h-.088v-.088h4.6v.088h-.088v-.351h.088l-.038.08c-.609-.29-1.275-.97-1.986-2.643l-6.262-14.916.08-.035.037.08-2.474,1.111-.035-.083.08-.038.327.707-.083.038.079-.038a1.608,1.608,0,0,1,.052,1.434l-4.714,11.708-.08-.031.08.031c-.686,1.7-1.381,2.386-2.172,2.674Z",
    transform: "translate(-680.34 -465.43)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 112.07,
    height: 0.482,
    transform: "translate(0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 8.869,
    height: 8.474,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M776.022,824.516l-1.82-4.137-1.819,4.137Zm.422.962H771.96l-.928,2.112H769.79l3.823-8.44h1.192l3.834,8.44h-1.264l-.932-2.112Z",
    transform: "translate(-769.79 -819.15)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 12.304,
    height: 17.708,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M850.45,485.445v-.356c.833-.278,1.008-1.038,1.008-2.853V470.984c0-1.816-.175-2.575-1.008-2.853v-.351h4.695v.355c-.834.277-1.011,1.035-1.011,2.853v12.739a1.143,1.143,0,0,0,1.263,1.26h2.07c2.55,0,3.861-.6,4.869-2.775l.326.049-.2,3.18-12.012,0Z",
    transform: "translate(-850.45 -467.78)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 12.427,
    height: 17.895,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M849.81,484.892v-.419l.061-.02c.766-.258.948-.935.948-2.769h0V470.431h0c0-1.83-.184-2.516-.948-2.769l-.061-.018v-.5h4.871v.5l-.061.022c-.766.252-.95.935-.95,2.769h0v12.739h0a1.058,1.058,0,0,0,1.175,1.173v0h2.07v0c2.524,0,3.8-.593,4.793-2.727l.027-.061.474.075-.21,3.341H849.81v-.088m.175,0H849.9V484.8h12.012v.088l-.088-.007.2-3.18.088.007-.012.088-.327-.049.015-.088.08.038c-1.027,2.21-2.375,2.826-4.95,2.826h-2.07a1.228,1.228,0,0,1-1.35-1.348V470.434c0-1.8.17-2.634,1.069-2.933l.03.084h-.088v-.355h.088v.088H849.9v-.088h.088v.355H849.9l.03-.084c.9.3,1.066,1.134,1.066,2.933V481.69c0,1.8-.168,2.634-1.066,2.933l-.03-.084h.088v.351Z",
    transform: "translate(-849.81 -467.14)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M906.47,819.15h1.206v7.391H906.47Zm0,7.391h5.775v1.05H906.47Z",
    transform: "translate(-906.47 -819.15)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 10.835,
    height: 10.835,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M914.735,685.85h1.845v2.215h-1.845Zm-2.215,2.217H918.8v1.845H912.52Zm2.215,1.844h1.845v2.218h-1.845Z",
    transform: "translate(-912.52 -685.85)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M1101.89,826.015l.447-.943a4.354,4.354,0,0,0,2.785.977c1.458,0,2.088-.566,2.088-1.3,0-2.065-5.116-.76-5.116-3.9,0-1.3,1.016-2.409,3.233-2.409a4.938,4.938,0,0,1,2.712.749l-.4.963a4.349,4.349,0,0,0-2.314-.688c-1.434,0-2.05.6-2.05,1.337,0,2.062,5.113.775,5.113,3.872,0,1.29-1.035,2.4-3.268,2.4a5.03,5.03,0,0,1-3.231-1.061v0Z",
    transform: "translate(-1101.89 -818.44)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 12.997,
    height: 17.743,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M1064.19,485.445v-.356c.833-.278,1.008-1.038,1.008-2.853V470.984c0-1.816-.175-2.575-1.008-2.853v-.351h12.11l.277,3.56-.329.073c-1.005-2.47-2.6-3.227-5.422-3.227h-2.949v7.569h2.422c3.078,0,3.964-.6,4.364-1.918h.355v4.239h-.355c-.4-1.313-1.286-1.918-4.364-1.918h-2.422v7.621a1.141,1.141,0,0,0,1.26,1.26h2.421c2.547,0,4.289-.756,5.248-3.33l.327.049-.175,3.686h-12.766Z",
    transform: "translate(-1064.19 -467.78)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 13.127,
    height: 17.871,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M1063.55,484.892v-.419l.058-.02c.766-.258.95-.935.95-2.769h0V470.431h0c0-1.83-.187-2.516-.95-2.769l-.058-.018v-.5h12.282l.29,3.713-.473.11-.027-.072c-.992-2.43-2.544-3.174-5.345-3.174h-2.949v-.084h.088V475.2h-.088v-.088h2.423v0c3.07,0,3.9-.6,4.28-1.853l.017-.064h.5v4.416h-.509l-.018-.062c-.386-1.255-1.207-1.856-4.28-1.856h-2.423v-.088h.088v7.621h0a1.057,1.057,0,0,0,1.173,1.173v0h2.421v0c2.522,0,4.223-.745,5.163-3.275l.026-.066.478.073-.183,3.848h-12.938v-.088m.173,0h-.088V484.8H1076.4v.088l-.088,0,.175-3.686.088,0-.015.088-.326-.049.012-.088.08.031c-.975,2.617-2.758,3.387-5.328,3.387h-2.422a1.229,1.229,0,0,1-1.348-1.348v-7.709h2.511c3.089,0,4.028.608,4.448,1.982l-.084.024v-.088h.355v.088h-.088v-4.239h.088v.088h-.355v-.088l.084.024c-.421,1.374-1.363,1.982-4.448,1.982h-2.511v-7.746h3.037c2.851,0,4.479.769,5.506,3.284l-.08.031-.022-.084.331-.073.02.084-.088.007-.277-3.56.089-.007v.088h-12.113v-.088h.088v.355h-.088l.027-.084c.9.3,1.069,1.134,1.069,2.933v11.256c0,1.8-.17,2.634-1.069,2.933l-.027-.084h.088v.355Z",
    transform: "translate(-1063.55 -467.14)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 12.456,
    height: 18.117,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M1209.939,482.789l-.1-3.786.327-.049c1.061,2.876,3.306,5.1,6.66,5.1a3.145,3.145,0,0,0,3.356-3.18c0-2.474-3.253-3.633-5.273-4.441-2.6-1.085-4.77-1.943-4.77-4.869,0-3.127,2.522-5.072,6.484-5.072a10.891,10.891,0,0,1,4.845,1.059l.1,3.283-.277.1a5.97,5.97,0,0,0-5.629-4.011c-2.02,0-3.608,1.187-3.608,3.178,0,2.245,2.547,3.154,4.567,3.96,2.575.985,5.628,2.119,5.628,5.147,0,3.456-3.179,5.376-6.083,5.376A11.009,11.009,0,0,1,1209.939,482.789Z",
    transform: "translate(-1209.84 -466.49)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 12.708,
    height: 18.369,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M1209.291,482.24l-.1-3.865.473-.073.025.066c1.05,2.853,3.272,5.039,6.581,5.039v0a3.057,3.057,0,0,0,3.268-3.093h0c0-2.276-2.857-3.421-4.9-4.234l-.313-.122-.243-.1c-2.48-1.034-4.58-1.947-4.58-4.848h0c0-3.2,2.582-5.16,6.568-5.16v0a11.01,11.01,0,0,1,4.884,1.066l.046.026.1,3.4-.418.152-.031-.08a5.87,5.87,0,0,0-5.54-3.956c-1.986,0-3.52,1.158-3.52,3.09h0c0,2.073,2.249,2.98,4.239,3.773l.183.075.057.115.031-.08.161.064c2.519.962,5.52,2.131,5.52,5.167h0c0,3.52-3.238,5.46-6.17,5.46a11.09,11.09,0,0,1-6.285-1.81l-.035-.026v-.042m.174,0-.088,0,.053-.069a10.945,10.945,0,0,0,6.179,1.773c2.874,0,5.995-1.9,5.995-5.286,0-2.891-2.849-4.025-5.407-5l-.164-.064-.271-.109c-1.947-.775-4.349-1.719-4.349-3.935,0-2.055,1.643-3.266,3.7-3.266a6.054,6.054,0,0,1,5.708,4.068l-.08.031-.033-.084.278-.1.031.084-.089,0-.1-3.283.088,0-.04.079a10.784,10.784,0,0,0-4.8-1.05c-3.935,0-6.4,1.921-6.4,4.984,0,2.773,1.974,3.646,4.475,4.689l.2.084.007.1.031-.08.313.122c2,.791,5.018,1.978,5.018,4.4a3.231,3.231,0,0,1-3.444,3.268c-3.4,0-5.674-2.256-6.745-5.155l.08-.031.015.088-.327.047-.015-.088h.088l.1,3.781,0,0Z",
    transform: "translate(-1209.19 -465.85)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 6.149,
    height: 8.444,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M1231.108,826.541v1.046h-6.127V819.15h5.955v1.05h-4.749v2.592h4.232v1.025h-4.232v2.727Z",
    transform: "translate(-1224.98 -819.15)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M1352.329,822.092c0-1.2-.809-1.892-2.351-1.892h-2.051V824h2.051c1.542,0,2.351-.7,2.351-1.9m.034,5.5L1350.542,825c-.168.011-.347.026-.53.026h-2.086v2.567h-1.206v-8.44h3.292c2.192,0,3.52,1.108,3.52,2.942a2.67,2.67,0,0,1-1.858,2.668l2,2.834-1.313,0Z",
    transform: "translate(-1346.72 -819.15)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 51.589,
    height: 22.05,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M426.153,152.386l10.072-8.634.229.267-.229-.267a1.887,1.887,0,0,1,1.784-.366l-.1.335.1-.335,4.444,1.389-.1.334.1-.334a1.166,1.166,0,0,0,1.171-.282l.005-.007,15.181-12.928.229.267-.247-.254a1.876,1.876,0,0,1,2.55-.062l.018.016,5.824,6.815-.267.229.232-.263,10.36,9.106-.465.526-10.387-9.146L460.849,132l.267-.229-.232.263a1.172,1.172,0,0,0-1.6.042l-.007.007L444.1,145.011l-.229-.267.245.254a1.87,1.87,0,0,1-1.872.445l-4.448-1.386a1.179,1.179,0,0,0-1.116.229l-10.072,8.634-.457-.535Z",
    transform: "translate(-426.15 -131.039)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 63.38,
    height: 31.412,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M787.749,45.389,783.69,30.514l.339-.091-.339.091a1.175,1.175,0,0,0-.513-.69L759.428,15.069a1.178,1.178,0,0,0-1.427.145l-5.125,4.82a1.888,1.888,0,0,1-1.536.5l.046-.347-.046.347L747,19.949a1.169,1.169,0,0,0-.92.274L725.527,37.835l-.457-.534,20.549-17.615.229.267-.229-.267a1.894,1.894,0,0,1,1.473-.435l-.046.347.046-.347,4.342.581a1.179,1.179,0,0,0,.962-.309l.237.256-.241-.256,5.125-4.82.243.256-.243-.256a1.882,1.882,0,0,1,2.28-.229l-.184.3.184-.3,23.75,14.755-.187.3.187-.3a1.872,1.872,0,0,1,.822,1.1l4.056,14.878Z",
    transform: "translate(-725.07 -14.191)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-61"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 38.214,
    height: 17.266,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M1201.652,121.673l-4.152-3.834a1.18,1.18,0,0,0-1.381-.157l-.175-.305.175.305-6.084,3.478-.175-.305.175.305a1.883,1.883,0,0,1-2.218-.26l.24-.256-.24.256-16.254-15.241a1.176,1.176,0,0,0-1.663.053l-.077.088-.046.066-5.266,6.079-.531-.461,5.257-6.064.267.229-.289-.2.114-.152.063-.066a1.878,1.878,0,0,1,2.653-.085l-.24.258.24-.258,16.255,15.241a1.176,1.176,0,0,0,1.386.163l6.084-3.478a1.88,1.88,0,0,1,2.207.248l-.237.256.237-.256,4.154,3.834Z",
    transform: "translate(-1163.98 -104.638)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 16.851,
    height: 33.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M566.13,168.845l5.916-6.075a1.173,1.173,0,0,0,.426-.906h0v-3.939h0a1.871,1.871,0,0,1,.654-1.422l.229.267-.229-.267,8.512-7.343.229.267-.229-.267a1.188,1.188,0,0,0,.373-1.184l0-.011-2.313-11.5.69-.137,2.307,11.491-.344.072.341-.088a1.877,1.877,0,0,1-.593,1.89l-8.514,7.343a1.161,1.161,0,0,0-.406.887v3.943a1.885,1.885,0,0,1-.682,1.447l-.225-.271.255.246-5.889,6.047-.5-.492Z",
    transform: "translate(-566.13 -136.33)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 12.012,
    height: 44.833,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M982.96,61.282l-8.317-17.168.316-.153-.316.153a1.88,1.88,0,0,1,.4-2.185l4.9-4.609.242.256-.242-.256a1.183,1.183,0,0,0,.267-1.339l-8.5-18.952.64-.288,8.5,18.952-.32.145.32-.145a1.878,1.878,0,0,1-.424,2.135l-4.9,4.61-.242-.256.242.256a1.18,1.18,0,0,0-.252,1.37l8.313,17.168-.629.305Z",
    transform: "translate(-971.71 -16.74)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 11.233,
    height: 34.738,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M1210.7,107.061c.672,10.109,7.526,16.788,9.794,18.949l-.241.252.241-.252a1.864,1.864,0,0,1,.431,2.055l-.326-.133.326.133-2.736,6.735a2.15,2.15,0,0,1-.454.688l-.248-.246.252.241-5.811,6.043-.5-.488,5.813-6.047a1.424,1.424,0,0,0,.3-.456l.327.133-.327-.133,2.737-6.735a1.159,1.159,0,0,0-.267-1.283c-2.281-2.17-9.321-9.01-10.013-19.411l.7-.047Z",
    transform: "translate(-1210 -107.06)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 10.812,
    height: 9.361,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M448.49,236.3,458.961,227l.171.2Z",
    transform: "translate(-448.49 -227)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-71"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 11.026,
    height: 9.361,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M468.24,242.406l10.468-9.3.172.2Z",
    transform: "translate(-468.24 -233.11)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-73"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 27.044,
    height: 23.298,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M473.37,176.534l26.739-23.114.171.2Z",
    transform: "translate(-473.37 -153.42)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-75"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 24.131,
    height: 21.426,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M499.89,189.257l23.844-21.117.171.2L499.89,189.253Z",
    transform: "translate(-499.89 -168.14)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-77"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 21.536,
    height: 19.553,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M521.853,209.4l21.163-19.253.176.2L521.85,209.4Z",
    transform: "translate(-521.85 -190.15)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-79"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 20.964,
    height: 19.763,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M532.33,225.623l20.558-19.473.181.194Z",
    transform: "translate(-532.33 -206.15)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-81"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 8.529,
    height: 8.17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M555.26,305.411l8.077-7.951.182.191Z",
    transform: "translate(-555.26 -297.46)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-83"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 20.108,
    height: 17.604,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M753.66,73.462,773.338,56.02l.171.2Z",
    transform: "translate(-753.66 -56.02)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-85"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 20.802,
    height: 19.074,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M768.65,76.427,788.967,57.6l.18.194Z",
    transform: "translate(-768.65 -57.6)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-87"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 26.419,
    height: 24.358,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M784.63,49.766,810.74,25.56l.178.194L784.63,49.762Z",
    transform: "translate(-784.63 -25.56)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-89"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 25.795,
    height: 24.339,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M796.9,64.219l25.447-24.2.179.193L796.9,64.222Z",
    transform: "translate(-796.9 -40.02)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-91"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 25.795,
    height: 24.279,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M803.044,84.179l25.446-24.2.18.194L803.04,84.179Z",
    transform: "translate(-803.04 -59.98)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-93"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 28.105,
    height: 27.143,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M794.42,103.981,822.213,76.93l.183.187Z",
    transform: "translate(-794.42 -76.93)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-95"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 28.057,
    height: 27.251,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M804.93,120.261,832.724,93.21l.182.19Z",
    transform: "translate(-804.93 -93.21)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-97"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 24.547,
    height: 24.131,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M836.62,136.025,860.8,111.96l.187.186Z",
    transform: "translate(-836.62 -111.96)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-99"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 24.547,
    height: 24.286,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M843.86,154.285l24.179-24.065.185.186Z",
    transform: "translate(-843.86 -130.22)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-101"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 24.547,
    height: 24.304,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M853.68,173.378l24.176-24.068.187.186L853.68,173.375Z",
    transform: "translate(-853.68 -149.31)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-103"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 16.433,
    height: 16.018,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M879.16,230.718l15.915-15.908.185.186-16.1,15.718Z",
    transform: "translate(-879.16 -214.81)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-105"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 16.227,
    height: 16.122,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M1126.85,216.215l15.915-15.905.184.184-16.1,15.717Z",
    transform: "translate(-1126.85 -200.31)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-107"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 13.521,
    height: 13.313,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M907.23,249.427l13.112-13.137.186.187-13.3,12.945Z",
    transform: "translate(-907.23 -236.29)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-109"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 12.898,
    height: 12.898,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M921.22,269.342,933.8,256.73l.186.186Z",
    transform: "translate(-921.22 -256.73)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-111"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 10.726,
    height: 10.817,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M946.03,286.255l10.53-10.585.186.186Z",
    transform: "translate(-946.03 -275.67)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-113"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 8.226,
    height: 8.17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M974.08,305.373l7.841-7.933.186.186-8.027,7.744Z",
    transform: "translate(-974.08 -297.44)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-115"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 6.657,
    height: 6.865,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M997.163,321.134l6.241-6.724.191.182-6.436,6.543Z",
    transform: "translate(-997.16 -314.41)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-117"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 6.657,
    height: 6.865,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M1168.993,131.144l6.244-6.724.189.183-6.435,6.541Z",
    transform: "translate(-1168.99 -124.42)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-119"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 5.501,
    height: 5.824,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M1181.41,148.721l5.2-5.631.191.183Z",
    transform: "translate(-1181.41 -143.09)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-121"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 5.582,
    height: 5.824,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M1185.87,170.392l5.2-5.632.19.183Z",
    transform: "translate(-1185.87 -164.76)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-123"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 5.498,
    height: 5.681,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M1194.83,189.532l5.2-5.632.189.183Z",
    transform: "translate(-1194.83 -183.9)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-125"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 14.146,
    height: 14.043,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M1154.15,229.483l13.805-13.823.187.186Z",
    transform: "translate(-1154.15 -215.66)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-127"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 12.898,
    height: 12.483,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M1179.52,242.576,1191.9,230.16l.187.186-12.567,12.231Z",
    transform: "translate(-1179.52 -230.16)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-129"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 12.688,
    height: 12.644,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M1192.38,258.945l12.384-12.415.185.187-12.566,12.228Z",
    transform: "translate(-1192.38 -246.53)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-131"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 10.542,
    height: 10.401,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M1205.37,286.983l10.245-10.3.186.185Z",
    transform: "translate(-1205.37 -276.68)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-133"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 8.638,
    height: 8.474,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M1472.741,819.15l-3.7,8.44h-1.2l-3.713-8.44h1.3l3.04,6.935,3.063-6.935Z",
    transform: "translate(-1464.13 -819.15)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-135"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 1.205,
    height: 8.44,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-136"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 13.573,
    height: 17.79,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M1350.373,485.109c.833-.278,1.012-1.038,1.012-2.853v-14h-.787c-2.245,0-3.379.631-4.315,2.648l-.3-.047.152-3.054h13.145l.152,3.054-.3.047c-.935-2.02-2.07-2.648-4.315-2.648h-.73v14c0,1.815.175,2.575,1.008,2.853v.355h-4.719v-.355Z",
    transform: "translate(-1345.98 -467.8)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-138"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 13.742,
    height: 17.958,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M1349.765,484.464c.765-.256.948-.935.948-2.769h0v-14h.088v.088h-.783c-2.215,0-3.315.615-4.232,2.6l-.03.058-.446-.073.162-3.215h13.312l.161,3.215-.446.073-.027-.058c-.92-1.985-2.024-2.6-4.238-2.6h-.73v-.088h.088v14h0c0,1.83.187,2.512.948,2.769l.061.02v.507h-4.895v-.507l.061-.02m.053.164-.03-.084h.088v.355h-.088v-.088h4.719v.088h-.088v-.351h.088l-.03.084c-.9-.3-1.066-1.134-1.066-2.933V467.6h.818c2.276,0,3.447.646,4.4,2.7l-.08.035-.015-.088.3-.047.015.088h-.088l-.152-3.051.088,0v.088h-13.145v-.091l.088,0-.152,3.054-.088,0,.015-.088.3.047-.015.088-.08-.035c.954-2.051,2.119-2.7,4.4-2.7h.871V481.7c0,1.8-.168,2.634-1.07,2.933h0Z",
    transform: "translate(-1345.31 -467.15)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-140"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 17.191,
    height: 17.958,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M1479.219,477.177l-3.253-7.8-3.154,7.8h6.408Zm-10.619,6.636c.754-.278,1.437-.935,2.118-2.624l4.719-11.711a1.541,1.541,0,0,0-.049-1.363l-.327-.707,2.474-1.108,6.254,14.912c.707,1.664,1.363,2.322,1.941,2.6v.355h-4.59v-.355c.833-.278.477-.935-.229-2.6l-1.51-3.633h-6.739l-1.465,3.608c-.681,1.689-.529,2.421.327,2.624v.355H1468.6v-.355Z",
    transform: "translate(-1468.6 -466.3)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-142"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 17.368,
    height: 18.21,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M1478.577,476.456l-3.253-7.795.08-.035.08.031-3.154,7.795-.08-.031v-.088h6.408v.088l-.08.035m.16-.066.049.122h-6.667l3.28-8.115,3.337,8v0ZM1468,482.977c.724-.267,1.393-.9,2.07-2.576l.08.033-.08-.033,4.719-11.706.08.031-.08-.031a1.436,1.436,0,0,0-.049-1.294l-.366-.787,2.634-1.184,6.293,15-.08.035.08-.035c.7,1.654,1.348,2.291,1.9,2.554l.047.024v.5h-4.767V483l.061-.02c.456-.152.519-.408.309-1.04-.1-.29-.255-.654-.442-1.1l-.145-.342-1.517-3.632.08-.035v.088H1472.1v-.088l.08.031-1.46,3.612-.083-.031.083.031c-.629,1.559-.514,2.21.073,2.444l.122.042.137.033v.509h-3.1V483l.054-.02m.061.163-.031-.08h.088v.355h-.084v-.088h2.926v.088h-.088v-.355h.088l-.022.084-.15-.042-.068-.027c-.757-.305-.787-1.145-.168-2.675l1.485-3.663h6.85l1.538,3.688-.08.035.08-.035.145.336c.19.446.347.817.45,1.118.221.656.183,1.061-.419,1.26l-.027-.084h.088v.355h-.088v-.088h4.591v.088h-.088v-.351h.088l-.038.08c-.608-.29-1.275-.97-1.985-2.643l-6.259-14.916.08-.035.035.08-2.472,1.111-.035-.083.08-.038.326.707-.08.038.078-.038a1.6,1.6,0,0,1,.053,1.434l-4.715,11.708c-.684,1.7-1.38,2.386-2.171,2.674Z",
    transform: "translate(-1467.95 -465.43)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-144"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 13.489,
    height: 17.79,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M1621.393,485.109c.833-.278,1.008-1.038,1.008-2.853v-14h-.783c-2.245,0-3.379.631-4.315,2.648l-.3-.047.152-3.054H1630.3l.152,3.054-.3.047c-.935-2.016-2.07-2.648-4.315-2.648h-.73v14c0,1.815.175,2.575,1.008,2.853v.355h-4.719v-.355Z",
    transform: "translate(-1617 -467.8)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-146"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 13.72,
    height: 17.958,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M1620.8,484.464c.761-.256.948-.935.948-2.769h0v-14h.088v.088h-.783c-2.214,0-3.317.615-4.234,2.6l-.027.058-.446-.073.159-3.215h13.313l.163,3.215-.446.073-.03-.058c-.917-1.985-2.02-2.6-4.232-2.6h-.73v-.088h.088v14h0c0,1.83.185,2.512.948,2.769l.061.02v.507h-4.9v-.507l.061-.02m.053.164-.027-.084h.088v.355h-.088v-.088h4.719v.088h-.088v-.351h.088l-.03.084c-.9-.3-1.066-1.134-1.066-2.933V467.6h.818c2.276,0,3.444.646,4.395,2.7l-.08.035-.015-.088.3-.047.014.088h-.088l-.152-3.051.088,0v.088h-13.145v-.091l.088,0-.152,3.054-.088,0,.015-.088.3.047-.015.088-.08-.035c.948-2.051,2.119-2.7,4.4-2.7h.871v14.094c0,1.8-.169,2.634-1.069,2.933Z",
    transform: "translate(-1616.35 -467.15)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-148"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 7.711,
    height: 8.642,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M1682.381,822.758a4.271,4.271,0,0,1,4.475-4.318,4.18,4.18,0,0,1,3.208,1.313l-.787.76a3.128,3.128,0,0,0-2.375-1,3.243,3.243,0,1,0,0,6.484,3.148,3.148,0,0,0,2.375-1.012l.783.76a4.2,4.2,0,0,1-3.219,1.328,4.266,4.266,0,0,1-4.461-4.315Z",
    transform: "translate(-1682.38 -818.44)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-150"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 112.07,
    height: 0.482,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-151"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 12.99,
    height: 17.742,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M1764.52,485.445v-.356c.833-.278,1.008-1.038,1.008-2.853V470.984c0-1.816-.175-2.575-1.008-2.853v-.351h12.11l.278,3.56-.331.073c-1-2.47-2.595-3.227-5.419-3.227h-2.952v7.569h2.421c3.078,0,3.964-.6,4.364-1.918h.356v4.239H1775c-.4-1.313-1.286-1.918-4.364-1.918h-2.424v7.621a1.142,1.142,0,0,0,1.26,1.26h2.424c2.548,0,4.289-.756,5.25-3.33l.325.049-.175,3.686h-12.771Z",
    transform: "translate(-1764.52 -467.78)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M1763.87,484.892v-.419l.061-.02c.765-.258.948-.935.948-2.769h0V470.431h0c0-1.83-.187-2.516-.948-2.769l-.061-.018v-.5h12.282l.293,3.713-.476.11-.027-.072c-.99-2.43-2.543-3.174-5.343-3.174h-2.952v-.084h.088V475.2h-.088v-.088h2.421v0c3.07,0,3.9-.6,4.281-1.853l.018-.064h.5v4.416h-.509l-.018-.062c-.386-1.255-1.207-1.856-4.281-1.856h-2.421v-.088h.088v7.621h0a1.057,1.057,0,0,0,1.173,1.173v0h2.424v0c2.523,0,4.223-.745,5.166-3.275l.025-.066.478.073-.183,3.848h-12.942v-.088m.175,0h-.088V484.8h12.766v.088l-.088,0,.175-3.686.088,0-.012.088-.327-.049.015-.088.08.031c-.977,2.617-2.758,3.387-5.33,3.387H1768.9a1.23,1.23,0,0,1-1.349-1.348v-7.709h2.508c3.089,0,4.025.608,4.448,1.982l-.084.024v-.088h.355v.088h-.088v-4.239h.088v.088h-.347v-.088l.084.024c-.423,1.374-1.363,1.982-4.448,1.982h-2.512v-7.746h3.039c2.849,0,4.479.769,5.506,3.284l-.083.031-.021-.084.33-.073.022.084-.088.007-.278-3.56.088-.007v.088h-12.113v-.088h.088v.355h-.088l.027-.084c.9.3,1.069,1.134,1.069,2.933v11.256c0,1.8-.168,2.634-1.069,2.933l-.027-.084h.088v.355Z",
    transform: "translate(-1763.87 -467.14)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M1820.048,826.541v1.046h-6.128V819.15h5.955v1.05h-4.749v2.592h4.231v1.025h-4.231v2.727Z",
    transform: "translate(-1813.92 -819.15)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-evres",
    transform: "translate(-7.19 -13.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(8.035 75.358)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0.024 0.026)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M0,454.19H16.638v21.38H0Z",
    transform: "translate(-1.845 -456.034)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(7.97 75.294)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0.001 0.003)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M0,454.19H16.638v21.38H0Z",
    transform: "translate(-1.757 -455.947)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(8.458 123.049)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(0)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M16.54,819.15h6.813v8.435H16.54Z",
    transform: "translate(-16.54 -819.15)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(25.48 123.049)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M142.02,819.15h6.125v8.444H142.02Z",
    transform: "translate(-142.02 -819.15)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(26.808 75.358)",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(0.024 0.026)",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M138.39,454.19h20.241v21.348H138.39Z",
    transform: "translate(-140.235 -456.034)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(26.728 75.281)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0.016 0.016)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M138.39,454.19h20.241v21.348H138.39Z",
    transform: "translate(-140.147 -455.947)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(41.996 123.049)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(0)",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M263.77,819.15h6.956V827.6H263.77Z",
    transform: "translate(-263.77 -819.15)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(57.819 122.951)",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M384.9,818.43h6.5v8.632h-6.5Z",
    transform: "translate(-384.9 -818.432)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(58.954 75.331)",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(0.012 0.053)",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M380.03,454.19h18.347v21.5H380.03Z",
    transform: "translate(-381.874 -456.034)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(58.844 75.261)",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(0.038 0.037)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M380.03,454.19h18.347v21.5H380.03Z",
    transform: "translate(-381.788 -455.947)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(73.631 122.951)",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M502.92,818.43h8.969v8.634H502.92Z",
    transform: "translate(-502.92 -818.432)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(79.336 75.358)",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(0.023 0.026)",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M532.18,454.19h16.638v21.38H532.18Z",
    transform: "translate(-534.023 -456.034)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(79.27 75.294)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(0.001 0.003)",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M532.18,454.19h16.638v21.38H532.18Z",
    transform: "translate(-533.935 -455.947)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(92.66 123.049)",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M644.85,819.15h7.259v8.45H644.85Z",
    transform: "translate(-644.85 -819.15)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(97.407 75.182)",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(0.054 0.001)",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M667.41,452.49h20.822v21.555H667.41Z",
    transform: "translate(-669.255 -454.363)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(97.342 75.019)",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(0.028 0.046)",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M667.41,452.49h20.822v21.555H667.41Z",
    transform: "translate(-669.164 -454.245)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(7.19 107.866)",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M7.19,707.23H119.261v.479H7.19Z",
    transform: "translate(-7.19 -707.23)",
    fill: "#847763"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(109.399 123.049)",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(0)",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M769.79,819.15h8.836v8.44H769.79Z",
    transform: "translate(-769.79 -819.15)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(120.148 75.342)",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(0.042 0.042)",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M836.86,454.19h15.908v21.374H836.86Z",
    transform: "translate(-838.703 -456.034)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(120.087 75.281)",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(0.016 0.016)",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M836.86,454.19h15.908v21.374H836.86Z",
    transform: "translate(-838.617 -455.947)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(127.736 123.049)",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M906.47,819.15h5.776v8.438H906.47Z",
    transform: "translate(-906.47 -819.15)",
    fill: "#847763"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(126.268 102.69)",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M882.79,656.12h14.345v14.345H882.79Z",
    transform: "translate(-884.547 -657.877)",
    fill: "#e1322d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(128.544 104.966)",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M882.79,656.12h14.345v14.345H882.79Z",
    transform: "translate(-886.823 -660.153)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(153.926 122.951)",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M1101.9,818.43h6.5v8.632h-6.5Z",
    transform: "translate(-1101.899 -818.432)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(148.803 75.358)",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(0.024 0.026)",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M1050.6,454.19h16.637v21.38H1050.6Z",
    transform: "translate(-1052.444 -456.034)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(148.737 75.294)",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(0.003 0.003)",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M1050.6,454.19h16.637v21.38H1050.6Z",
    transform: "translate(-1052.357 -455.947)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(168.327 75.189)",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(0.022 0.02)",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M1196.23,452.89h16.1v21.766h-16.1Z",
    transform: "translate(-1198.076 -454.735)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(168.2 75.062)",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(0.06 0.06)",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M1196.23,452.89h16.1v21.766h-16.1Z",
    transform: "translate(-1197.988 -454.648)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(170.429 123.049)",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M1224.98,819.15h6.126v8.444h-6.126Z",
    transform: "translate(-1224.98 -819.15)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(186.742 123.049)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(-0.001)",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M1346.73,819.15h6.956V827.6h-6.956Z",
    transform: "translate(-1346.729 -819.15)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(63.11 29.61)",
    clipPath: "url(#clip-path-57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(0.088 0.094)",
    clipPath: "url(#clip-path-58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-414.974 -17.776)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(103.061 13.8)",
    clipPath: "url(#clip-path-59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(0.007 0.053)",
    clipPath: "url(#clip-path-60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-455.524 -1.925)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(161.917 26.074)",
    clipPath: "url(#clip-path-61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(0.057 0.049)",
    clipPath: "url(#clip-path-62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-515.063 -14.195)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(81.926 30.268)",
    clipPath: "url(#clip-path-63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(0.148 0.153)",
    clipPath: "url(#clip-path-64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-433.963 -18.494)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(136.402 14.009)",
    clipPath: "url(#clip-path-65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(0.039 0.19)",
    clipPath: "url(#clip-path-66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-488.981 -2.271)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(168.259 26.283)",
    clipPath: "url(#clip-path-67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(0.122 0.168)",
    clipPath: "url(#clip-path-68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-521.306 -14.523)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(66.33 42.716)",
    clipPath: "url(#clip-path-69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    transform: "translate(0 0.005)",
    clipPath: "url(#clip-path-70)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-418.005 -30.793)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(68.796 43.549)",
    clipPath: "url(#clip-path-71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(0.183 0.001)",
    clipPath: "url(#clip-path-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-420.684 -31.622)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(69.564 32.73)",
    clipPath: "url(#clip-path-73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(0.046 0.009)",
    clipPath: "url(#clip-path-74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-421.38 -20.812)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(73.066 34.602)",
    clipPath: "url(#clip-path-75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(0.107 0.134)",
    clipPath: "url(#clip-path-76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-424.977 -22.809)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(76.047 37.515)",
    clipPath: "url(#clip-path-77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(0.076 0.208)",
    clipPath: "url(#clip-path-78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-427.956 -25.795)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(77.437 39.803)",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(0.092 0.09)",
    clipPath: "url(#clip-path-80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-429.378 -27.965)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(80.52 52.077)",
    clipPath: "url(#clip-path-81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(0.129 0.202)",
    clipPath: "url(#clip-path-82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-432.488 -40.351)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(107.043 19.495)",
    clipPath: "url(#clip-path-83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(0.137 0.033)",
    clipPath: "url(#clip-path-84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-459.402 -7.599)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(109.023 19.626)",
    clipPath: "url(#clip-path-85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(0.161 0.115)",
    clipPath: "url(#clip-path-86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-461.435 -7.814)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(111.249 15.279)",
    clipPath: "url(#clip-path-87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(0.041 0.117)",
    clipPath: "url(#clip-path-88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-463.603 -3.467)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(112.895 17.336)",
    clipPath: "url(#clip-path-89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(0.042 0.02)",
    clipPath: "url(#clip-path-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-465.268 -5.429)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(113.717 20.041)",
    clipPath: "url(#clip-path-91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(0.042 0.023)",
    clipPath: "url(#clip-path-92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-466.1 -8.136)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(112.546 22.33)",
    clipPath: "url(#clip-path-93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(0.045 0.034)",
    clipPath: "url(#clip-path-94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-464.931 -10.436)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(113.933 24.411)",
    clipPath: "url(#clip-path-95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(0.065 0.161)",
    clipPath: "url(#clip-path-96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-466.357 -12.644)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(118.243 27.113)",
    clipPath: "url(#clip-path-97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(0.02 0.003)",
    clipPath: "url(#clip-path-98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-470.656 -15.188)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(119.064 29.403)",
    clipPath: "url(#clip-path-99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(0.171 0.19)",
    clipPath: "url(#clip-path-100)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-471.638 -17.665)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(120.502 32.142)",
    clipPath: "url(#clip-path-101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(0.046 0.041)",
    clipPath: "url(#clip-path-102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-472.97 -20.254)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(123.84 41.05)",
    clipPath: "url(#clip-path-103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(0.174 0.018)",
    clipPath: "url(#clip-path-104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-476.426 -29.14)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(157.124 38.972)",
    clipPath: "url(#clip-path-105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(0.075 0.129)",
    clipPath: "url(#clip-path-106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-510.026 -27.173)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(127.762 43.964)",
    clipPath: "url(#clip-path-107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(0.03 0.018)",
    clipPath: "url(#clip-path-108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-480.234 -32.054)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(129.615 46.667)",
    clipPath: "url(#clip-path-109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(0.056 0.087)",
    clipPath: "url(#clip-path-110)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-482.132 -34.826)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(133.007 49.164)",
    clipPath: "url(#clip-path-111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(0.001 0.16)",
    clipPath: "url(#clip-path-112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-485.498 -37.396)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(136.726 52.077)",
    clipPath: "url(#clip-path-113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    transform: "translate(0.058 0.199)",
    clipPath: "url(#clip-path-114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-489.303 -40.349)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(139.726 54.572)",
    clipPath: "url(#clip-path-115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(0.163 0.007)",
    clipPath: "url(#clip-path-116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-492.434 -42.651)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(162.748 28.779)",
    clipPath: "url(#clip-path-117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(0.174 0.027)",
    clipPath: "url(#clip-path-118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-515.743 -16.878)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(164.516 31.274)",
    clipPath: "url(#clip-path-119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(0.079 0.065)",
    clipPath: "url(#clip-path-120)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-517.428 -19.411)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(165.016 34.187)",
    clipPath: "url(#clip-path-121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(0.176 0.091)",
    clipPath: "url(#clip-path-122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-518.033 -22.35)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(166.367 36.826)",
    clipPath: "url(#clip-path-123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(0.026 0.049)",
    clipPath: "url(#clip-path-124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-519.248 -24.947)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(160.837 41.05)",
    clipPath: "url(#clip-path-125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(0.035 0.133)",
    clipPath: "url(#clip-path-126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-513.73 -29.255)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(164.136 43.131)",
    clipPath: "url(#clip-path-127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(0.148 0.019)",
    clipPath: "url(#clip-path-128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-517.171 -31.222)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(165.988 45.257)",
    clipPath: "url(#clip-path-129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(0.019 0.114)",
    clipPath: "url(#clip-path-130)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-518.916 -33.443)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(167.715 49.372)",
    clipPath: "url(#clip-path-131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(0.05 0.088)",
    clipPath: "url(#clip-path-132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M413.22,0H554.883V53.253H413.22Z",
    transform: "translate(-520.678 -37.533)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(202.462 123.049)",
    clipPath: "url(#clip-path-133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    clipPath: "url(#clip-path-134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M1464.13,819.15h8.606v8.44h-8.606Z",
    transform: "translate(-1464.13 -819.15)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(220.036 123.049)",
    clipPath: "url(#clip-path-135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M1597.71,819.15h1.2v8.44h-1.2Z",
    transform: "translate(-1597.71 -819.15)",
    fill: "#847763"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(186.506 75.334)",
    clipPath: "url(#clip-path-136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(0.076 0.053)",
    clipPath: "url(#clip-path-137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M1332.36,452.49h53.872v21.582H1332.36Z",
    transform: "translate(-1334.208 -454.567)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(186.421 75.25)",
    clipPath: "url(#clip-path-138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(0.069 0.049)",
    clipPath: "url(#clip-path-139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M1332.36,452.49h53.872v21.582H1332.36Z",
    transform: "translate(-1334.117 -454.479)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(202.504 75.166)",
    clipPath: "url(#clip-path-140)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(0.018 0.018)",
    clipPath: "url(#clip-path-141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M1332.36,452.49h53.872v21.582H1332.36Z",
    transform: "translate(-1350.841 -454.363)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143",
    transform: "translate(202.418 74.996)",
    clipPath: "url(#clip-path-142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(0.015 0.069)",
    clipPath: "url(#clip-path-143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M1332.36,452.49h53.872v21.582H1332.36Z",
    transform: "translate(-1350.753 -454.245)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    transform: "translate(222.652 75.334)",
    clipPath: "url(#clip-path-144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(0 0.053)",
    clipPath: "url(#clip-path-145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M1332.36,452.49h53.872v21.582H1332.36Z",
    transform: "translate(-1370.972 -454.567)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(222.506 75.25)",
    clipPath: "url(#clip-path-146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(0.058 0.049)",
    clipPath: "url(#clip-path-147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M1332.36,452.49h53.872v21.582H1332.36Z",
    transform: "translate(-1370.884 -454.479)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(231.523 122.951)",
    clipPath: "url(#clip-path-148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(-0.001 0.001)",
    clipPath: "url(#clip-path-149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M1682.39,818.43h7.682v8.642h-7.682Z",
    transform: "translate(-1682.389 -818.432)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(144.108 107.866)",
    clipPath: "url(#clip-path-150)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M1037.99,707.23h112.07v.479H1037.99Z",
    transform: "translate(-1037.99 -707.23)",
    fill: "#847763"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(242.648 75.358)",
    clipPath: "url(#clip-path-151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151",
    transform: "translate(0.016 0.026)",
    clipPath: "url(#clip-path-152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M1750.92,454.19h16.636v21.38H1750.92Z",
    transform: "translate(-1752.765 -456.034)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(242.574 75.294)",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(0.001 0.003)",
    clipPath: "url(#clip-path-154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M1750.92,454.19h16.636v21.38H1750.92Z",
    transform: "translate(-1752.677 -455.947)",
    fill: "#847763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(249.365 123.049)",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    clipPath: "url(#clip-path-156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M1813.92,819.15h6.126v8.444h-6.126Z",
    transform: "translate(-1813.92 -819.15)",
    fill: "#847763"
  }))))));
};
export default SvgAgencyLogoBusiness;